import { FC, useState, useEffect } from "react";
import { Input } from "modules/common";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import { ThresholdInputProps } from "modules/common/components/Alarms/Form/components/CountiesStations/types/IThresholdInputProps";
import z from "zod";
import { thresholdInputSchema } from "modules/common/components/Alarms/Form/components/Measurements/schemas/ThresholdInputSchema";
import { ErrorMap, validateWithZod } from "modules/common/utils/validateWithZod";
import { IconButton } from "modules/common/components/Alarms/Form/components/IconButton";

const ThresholdInput: FC<ThresholdInputProps> = ({
    keyValue,
    title,
    amount,
    lookbackDays,
    onAmountChange,
    onLookbackDaysChange,
    removeThresholdInput,
}) => {
    const [errors, setErrors] = useState<ErrorMap<z.infer<typeof thresholdInputSchema>>>({});

    useEffect(() => {
        const validation = validateWithZod(thresholdInputSchema, { amount, lookbackDays });
        if (validation.success) {
            setErrors({});
        } else {
            setErrors(validation.errors);
        }
    }, [amount, lookbackDays]);

    function handleInputChange(
        e: React.ChangeEvent<HTMLInputElement>,
        callback: (keyValue: any, value?: number) => void
    ) {
        const stringValue = e.target.value;
        if (stringValue === "") {
            callback(keyValue, undefined);
        } else {
            const value = parseFloat(stringValue);
            callback(keyValue, isNaN(value) ? undefined : value);
        }
    }

    return (
        <div className="alarms-threshold-inputs">
            <label className="alarms-form-label">{title}</label>
            <div className="alarms-range-treshold-icon-and-inputs">
                <div className="alarms-form-range-treshold-container">
                    <div>
                        <Input
                            id={`amount-${keyValue}`}
                            name={`amount-${keyValue}`}
                            type="number"
                            size="medium"
                            value={amount ?? ""}
                            placeholder="Količina"
                            label="Količina"
                            isValid={!errors.amount}
                            errorMessage={errors.amount}
                            onChange={e => handleInputChange(e, onAmountChange)}
                        />
                    </div>
                    <div>
                        <Input
                            id={`days-${keyValue}`}
                            name={`days-${keyValue}`}
                            type="number"
                            size="medium"
                            value={lookbackDays ?? ""}
                            placeholder="Broj dana"
                            label="Broj dana"
                            isValid={!errors.lookbackDays}
                            errorMessage={errors.lookbackDays}
                            onChange={e => handleInputChange(e, onLookbackDaysChange)}
                        />
                    </div>
                    <IconButton onClick={() => removeThresholdInput(keyValue)} type="button">
                        <DeleteIcon />
                    </IconButton>
                </div>
            </div>
        </div>
    );
};

export default ThresholdInput;
